import script from "./AdministratorLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorLayout.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorLayout.vue?vue&type=style&index=0&id=1ad33974&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ad33974"]])

export default __exports__